import { ErrorBoundary as _ErrorBoundary } from 'fail-safe/ErrorBoundary';
class _ErrorBoundaryWithCallerPackage extends _ErrorBoundary {
  get failSafeCallerPackage() {
    return 'marketplace-embed';
  }
}
export { _ErrorBoundaryWithCallerPackage as ErrorBoundary };